<template>
    <div v-if="total > 0" class="flex flex-col gap-3 pt-4 sm:flex-row sm:items-center sm:justify-between">
        <p class="text-xs text-gray-400">
            Mostrando <strong class="text-gray-600">{{ start }}</strong> a <strong class="text-gray-600">{{ end }}</strong>
            de <strong class="text-gray-600">{{ total }}</strong> {{ itemLabel }}{{ total !== 1 ? 's' : '' }}
        </p>

        <div v-if="totalPages > 1" class="join">
            <button
                type="button"
                class="join-item btn btn-sm"
                :disabled="current <= 1"
                @click="go(current - 1)"
                title="Página anterior"
            >&laquo;</button>

            <button
                v-for="(p, i) in pages"
                :key="i"
                type="button"
                class="join-item btn btn-sm"
                :class="{
                    'btn-active !bg-cyan-500 !text-white !border-cyan-500': p === current,
                    'btn-disabled text-gray-400 cursor-default': p === '...'
                }"
                :disabled="p === '...'"
                @click="p !== '...' && go(p)"
            >{{ p }}</button>

            <button
                type="button"
                class="join-item btn btn-sm"
                :disabled="current >= totalPages"
                @click="go(current + 1)"
                title="Próxima página"
            >&raquo;</button>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';

export default {
    name: 'PaginationV2',
    props: {
        total: {
            type: Number,
            default: 0
        },
        limit: {
            type: Number,
            default: 10
        },
        current: {
            type: Number,
            default: 1
        },
        itemLabel: {
            type: String,
            default: 'resultado'
        }
    },
    emits: ['changePage'],
    setup(props, { emit }) {
        const totalPages = computed(() => Math.max(1, Math.ceil(props.total / props.limit)));

        const start = computed(() => {
            if (props.total === 0) return 0;
            return (props.current - 1) * props.limit + 1;
        });

        const end = computed(() => Math.min(props.current * props.limit, props.total));

        const pages = computed(() => {
            const tp = totalPages.value;
            const cur = props.current;

            if (tp <= 7) {
                return Array.from({ length: tp }, (_, i) => i + 1);
            }

            const result = [1];
            if (cur > 4) result.push('...');
            const from = Math.max(2, cur - 1);
            const to = Math.min(tp - 1, cur + 1);
            for (let i = from; i <= to; i++) result.push(i);
            if (cur < tp - 3) result.push('...');
            result.push(tp);
            return result;
        });

        function go(page) {
            if (page < 1 || page > totalPages.value || page === props.current) return;
            emit('changePage', page);
        }

        return { totalPages, start, end, pages, go };
    }
}
</script>
